import { render, staticRenderFns } from "./masterLayout.vue?vue&type=template&id=4ca46e2a&"
import script from "./masterLayout.vue?vue&type=script&lang=js&"
export * from "./masterLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports